export default {
  imageFilter: {
    tone: '色調',
    saturation: '彩度',
    brightness: '明るさ',
    ambiguity: 'ぼかし度',
    title: 'フィルター',
  },
  colorFilter: {
    title: 'カラー塗りつぶし',
  },
  colorPicker: {
    single: 'モノクロ',
    gradient: 'グラデーション',
  },
  fontLoader: {
    title: '共有フォントライブラリ',
    loading: 'フォントの読み込み中',
    currentFont: '現在のフォント',
    freeFont: '無料フォント（商用利用可）',
    systemFont: 'システムデフォルトフォント',
    forbidden: 'フォントがありません',
    all: '全て',
    applyFont: '同じ言語のテキストに適用',
    applyFontSuccess: '適用成功',
    assetFont: 'アップロード済み',
    assetFontTip:
      'カスタムアップロードされたフォントは、著作権を確認してください。',
  },
  fileMeta: {
    fileSize: 'ファイルサイズ',
    audioDuration: '音楽の長さ',
    imageSize: '画像サイズ',
  },
  orientationSelector: {
    vertical: '縦画面',
    horizontal: '横画面',
  },
  ratioSelector: {
    vertical: '縦',
    horizontal: '横',
  },
  storagefull: {
    tips: 'ストレージがいっぱいのため処理を完了できません。アセットライブラリのデータをクリーンアップするか、担当者に連絡してストレージを拡張してください。',
  },
  batchDeal: {
    selected: '選択された {num} 項目',
    selectAll: '全て選択',
    reverse: '反転選択',
    cancel: '全て解除',
  },
  translate: {
    selected: '選択されたテキスト {num} 個',
    selectAll: '全て選択',
    title: 'テキストの翻訳',
    error: 'この言語の翻訳は現在サポートされていません。',
    error1: '言語を変更するには、下記のテキストをすべて入力してください。',
    selectSource: '元の言語',
    select: '選択してください',
    commonLanguage: '一般的な言語',
    allLanguage: 'すべての言語',
    originLanguage: 'オリジナル',
    otherLanguage: 'その他の言語',
    selectTarget: 'ターゲット言語',
    translate: '翻訳（ベータ版）',
    error2: 'テキストを入力してください',
    error3: 'リクエストがタイムアウトしました。再試行してください。',
    error3Btn: '再試行してください。',
    track: 'テキストトラック',
    subtitleTrack: '字幕トラック',
    default: 'デフォルト言語',
    modify: '言語の変更',
    saveAs: 'プロジェクトを保存して置き換える',
    cancel: 'キャンセル',
    replace: '置換',
    add: '追加',
    done: '完了',
    saveAsSuccess: 'プロジェクトの保存に成功',
    selectSource1: '次の言語の選択',
    selectSource2: '翻訳対象のプロジェクト言語を選択',
  },
  forbiddenFontDialog: {
    title: 'フォントが見つかりません',
    forbiddenFont: 'フォントが見つかりません',
    replaceFont: 'フォントの置換',
  },
  videoClip: {
    clearSign: 'マーカーをクリア',
    resetSign: 'マーカーをリセット',
    tour: {
      step1: '進行バー上のマーカーをクリックすると、指定の地点に移動します。',
      step2:
        'ポインタをドラッグし、クリックしてマークを追加すると、ビデオを複数のセグメントに分割できます。',
      step3:
        '削除ボタンをクリックすると、分割されたビデオのマークが削除されます。',
      step4: '分割されたビデオセグメントはプロジェクトアセットに保存できます。',
    },
  },
  speech: {
    title: 'スマートダビング',
    labelLanguage: '字幕音声',
    labelType: '音声の種類',
    checkLabel: '英語を含む',
    lower: 'より低いトーン',
    low: '低いトーン',
    normal: '通常のトーン',
    high: '高いトーン',
    higher: 'より高いトーン',
  },
  assets: {
    transcode: {
      transcoding: '変換中',
      error: '変換失敗',
    },
  },
  upload: {
    renamedTip:
      'ファイル名が重複しています。別のファイル名でアップロードしました',
    successfully: 'ファイルがアップロードされました - {checkName}',
    fileStatus: {
      success: 'アップロード成功',
      error: 'アップロード失敗',
      uploading: 'アップロード中',
      invalid: 'サポートされていないファイル形式です',
      invalidType: '他のタイプのファイルのアップロードはできません',
      warningDragonboneSize: 'DragonBonesのサイズは{size}MB以下にしてください',
      warningXlzSize: 'フレームサイズは{size}MB以下にしてください',
      warningMaxSize: 'ファイルサイズは {size} MB以下にしてください',
      resolveError: 'ファイルの処理に失敗しました',
      verticesRules:
        '頂点、法線、テクスチャ座標がfalseの状態が存在する場合があります。',
      meshesRules: 'モデルメッシュの数が1ではありません。',
      materialRules: 'マテリアルの数が1ではありません。',
      skinRules: 'スキンの数が1ではありません。',
      skeletonRules: 'ボーンの名前がテンプレートと一致していません。',
    },
    sequenceFrameSizeDifferent: 'フレームの画像サイズが一致していません',
    sequenceFrameError:
      '指定された形式、およびサイズ要件を満たすフレームファイルをアップロードしてください',
    fontWaring:
      '対応可能なフォーマットは{type} 、サイズは{size}以下にしてください',
  },
  tour: {
    skip: 'スキップ',
    next: '次へ',
    finish: '了解',
  },
  resourceManager: {
    commonAudio: '共通効果音ライブラリ',
    commonBgm: '共通バックグラウンドミュージックライブラリ',
    commonAImage: '共通アニメーションライブラリ',
    commonModel: 'モデルライブラリ',
    commonAction: 'アニメライブラリ',
  },
  apiError:
    'インターフェースエラーが発生しました。後でもう一度試すか、開発者に連絡してください。',
  productDialog: {
    title: '関連製品',
    subtitle:
      '次のステップを実行するには、まず製品ストアのアドレスを関連付ける必要があります。',
    read: '読み込み中',
    placeholder: 'ストアのアドレスを入力してください',
    ok: '確認',
    cancel: 'キャンセル',
    add: '追加',
    urlError:
      'ストアのアドレスが正しくないため、製品情報を読み込むことができません',
  },
  projectNamePlaceholder: 'プロジェクト名',
  aiPrivacy: {
    title: 'AI生成コンテンツの免責事項',
    content:
      'PlayturboプラットフォームのAI関連サービス（以下、「本サービス」といいます）は生成型人工知能モデルに基づいています。ユーザーが自発的にこれらのサービスを利用することを選択した場合、本プラットフォームと本サービスに関連する契約および規則（<a href="https://app.playturbo.com/#/legal-agreement">プライバシーポリシーや Playturbo ユーザーサービス契約</a>を含むがこれに限定されない）に同意し、それらを遵守するものと見なされます。',
    cancel: '同意しない',
    agree: '同意する',
  },
  aiGenerationFunction: {
    long: '充実したコンテンツ',
    short: '簡略化されたコンテンツ',
    better: 'オリジナルの文章を改善',
    translate: '再翻訳',
  },
  aitool: {
    placeholderTip: 'コマンドを選択するか入力してください',
  },
  action: {
    search: '検索',
    replace: '置換',
    replaceAndTranslate: '置換して翻訳',
    cancel: 'キャンセル',
    findOutCount: '{num}箇所見つかりました',
  },
  tone: {
    search: {
      role: '役割',
      style: 'スタイル',
      model: 'ボイス',
    },
    style: {
      cheerful: '愉快',
      sad: '悲しみ',
      assistant: '助手',
      chat: 'チャット',
      customerservice: 'カスタマーサポート',
      newscast: 'ニュース放送',
      angry: '怒り',
      excited: '楽観的',
      friendly: 'フレンドリー',
      terrified: '恐怖',
      shouting: '叫ぶ',
      unfriendly: '無愛想',
      whispering: 'ささやき',
      hopeful: '希望に満ちた',
      narrationprofessional: 'ナレーション(プロ)',
      newscastcasual: 'ニュース(カジュアル)',
      newscastformal: 'ニュース(フォーマル)',
      empathetic: '思いやり',
      calm: '冷静',
      affectionate: '温かい',
      disgruntled: '不満',
      fearful: '恐れ',
      gentle: '礼儀正しい',
      lyrical: '哀愁',
      serious: 'シリアス',
      poetryreading: '詩の朗読',
      chatcasual: 'カジュアルなチャット',
      whisper: 'ささやき',
      sorry: '申し訳ない',
      narrationrelaxed: 'ナレーション(リラックス)',
      embarrassed: '恥ずかしい',
      depressed: '憂鬱',
      sportscommentary: 'スポーツ解説',
      sportscommentaryexcited: 'エキサイティングなスポーツ解説',
      documentarynarration: 'ナレーション(ドキュメンタリー)',
      envious: '羨ましそうな',
      advertisementupbeat: '陽気・明るい',
      livecommercial: 'リアルタイムコマーシャル',
    },
    role: {
      Narrator: 'ナレーター',
      YoungAdultMale: '若い男性',
      Boy: '男の子',
      YoungAdultFemale: '若い女性',
      OlderAdultFemale: '中年女性',
      OlderAdultMale: '中年男性',
      SeniorFemale: '高齢女性',
      SeniorMale: '高齢男性',
      Girl: '女の子',
    },
  },
  gender: {
    male: '男性',
    female: '女性',
    neutral: '無制限',
  },
}
